

export default {
        bind(el, binding) {
          const clipboard = new Clipboard(el, {
            text: () => binding.value
          });
      
          clipboard.on('success', (e) => {
            // Обработчик успешного копирования
            console.log('Текст успешно скопирован');
          });
      
          clipboard.on('error', (e) => {
            // Обработчик ошибки копирования
            console.error('Ошибка при копировании текста');
          });
        }
    }
    